import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import HeroCallToAction from "./sections/HeroCallToAction";
import VoresYdelser from "./sections/VoresYdelser";
import GetInTouch from "./sections/GetInTouch";
import PulseMetricsFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <HeroCallToAction />
      <VoresYdelser />
      <GetInTouch />
      <PulseMetricsFooter />
    </div>;
}